import { Component, OnInit } from '@angular/core'
import {ConfigService} from '../../services/config.service'
import {ErrorService} from '../../services/utils/error.service'

@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss']
})
export class ConsoleComponent implements OnInit {

  public show: boolean = false
  public logStack: {type: string, message: string, data: any}[] = []
  constructor(
      private configService: ConfigService,
      private errorService: ErrorService
  ) {}

  ngOnInit() {
    this.show = this.errorService.showLogger
    this.errorService.$showLogger.subscribe( (showLogger) => {
      this.show = showLogger
    })
    this.errorService.$log.subscribe( (logStack) => {
      this.logStack = logStack
    })
  }

  getData( data) {
    if ( data ) {
      if ( typeof( data ) === 'object' ) {
        return ' => ' + JSON.stringify( data )
      } else {
        return ' => ' + data.toString()
      }
    } else {
      return ''
    }
  }

  clean() {
    this.errorService.cleanLogs()
  }

}
